import { UseMutationResult, UseQueryResult, useMutation, useQuery } from '@tanstack/react-query'
import {
  GetCampaignRewardTypesResponse,
  GetCampaignConditionTypesResponse,
  CreateCampaignInput,
  CreateCampaignResponse,
  GetCampaignByIdResponse,
  UpdateCampaignInput,
  UpdateCampaignResponse,
} from 'services/interface'
import { 
  createCampaign, 
  getCampaignRewardTypes, 
  getCampaignConditionTypes,
  getCampaignById,
  updateCampaign,
} from 'services/campaignApi'

export const useGetCampaignRewardTypes = (): UseQueryResult<GetCampaignRewardTypesResponse, Error> => {
  return useQuery<GetCampaignRewardTypesResponse, Error>({
    queryKey: ['getCampaignRewardTypes'],
    queryFn: () => getCampaignRewardTypes(),
  })
}

export const useGetCampaignConditionTypes = (): UseQueryResult<GetCampaignConditionTypesResponse, Error> => {
  return useQuery<GetCampaignConditionTypesResponse, Error>({
    queryKey: ['getCampaignConditionTypes'],
    queryFn: () => getCampaignConditionTypes(),
  })
}

export const useCreateCampaign = (): UseMutationResult<
  CreateCampaignResponse,
  Error,
  CreateCampaignInput,
  unknown
> => {
  return useMutation<CreateCampaignResponse, Error, CreateCampaignInput, unknown>({
    mutationFn: (input: CreateCampaignInput) => createCampaign(input),
  })
}

export const useGetCampaignById = (id: string): UseQueryResult<GetCampaignByIdResponse, Error> => {
  return useQuery<GetCampaignByIdResponse, Error>({
    queryKey: ['getCampaignById', id],
    queryFn: () => getCampaignById(id),
    enabled: Boolean(id),
  })
}

export const useUpdateCampaign = (): UseMutationResult<
  UpdateCampaignResponse,
  Error,
  UpdateCampaignInput,
  unknown
> => {
  return useMutation<UpdateCampaignResponse, Error, UpdateCampaignInput, unknown>({
    mutationFn: (input: UpdateCampaignInput) => updateCampaign(input),
  })
}
